export enum ScheduledJobType {
	FirmwareUpdate = 'FIRMWARE_UPDATE'
}

export enum ScheduledJobStatus {
	Pending = 'PENDING',
	Executing = 'EXECUTING',
	Completed = 'COMPLETED',
	Failed = 'FAILED',
	Cancelled = 'CANCELLED',
	Missed = 'MISSED'
}
export interface ScheduledJob {
	id: string;
	jobId: string;
	jobName: string;
	jobType: ScheduledJobType;
	jobStatus: ScheduledJobStatus;
	deviceCount: number;
	executeAt: Date;
	createdBy: string;
	updatedBy: string;
	createdAt: Date;
	updatedAt: Date;
}
